/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSignContractDto
 */
export interface UpdateSignContractDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSignContractDto
     */
    selectedContractsIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSignContractDto
     */
    reason?: string;
}

/**
 * Check if a given object implements the UpdateSignContractDto interface.
 */
export function instanceOfUpdateSignContractDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateSignContractDtoFromJSON(json: any): UpdateSignContractDto {
    return UpdateSignContractDtoFromJSONTyped(json, false);
}

export function UpdateSignContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSignContractDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedContractsIds': !exists(json, 'selectedContractsIds') ? undefined : json['selectedContractsIds'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function UpdateSignContractDtoToJSON(value?: UpdateSignContractDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selectedContractsIds': value.selectedContractsIds,
        'reason': value.reason,
    };
}

